export const getLanguage = (locale) => {
    switch (locale) {
        case 'nl-NL':
            return 'nl';
        case 'de-DE':
            return 'de';
        case 'en-EU':
            return 'en'; // English (EU) is used for .com but that 'language' doesn't exist in the places api
        default:
            return locale;
    }
};
// replace char "&" and replace spaces with "-"
export const cleanUrl = (name) => name?.toLowerCase().replace('&', 'and').replace(/ /g, '-');
export const sortCountries = (data) => {
    return [
        ...data?.filter((country) => country.regionName === 'England'),
        ...data?.filter((country) => country.regionName === 'Scotland'),
        ...data?.filter((country) => country.regionName === 'Wales'),
        ...data?.filter((country) => country.regionName === 'Channel Islands'),
        ...data?.filter((country) => country.regionName === 'Isle of Man'),
    ];
};
export const sortRegions = (country, namesInOrder) => {
    return namesInOrder
        ?.map((regionName) => country.regions?.find((region) => region.regionName === regionName))
        .flat();
};
//# sourceMappingURL=utils.js.map